<template>
  <h1>404 PAGE NOT FOUND</h1>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
